import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const DivText = styled.div((props) => ({
  display:'flex',
  justifyContent:`${props.left?'flex-start':'center'}`,

  'div.priority.urgent': {
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  }
}))

export const StatusTag = styled.div((props) => ({
  fontFamily: 'IBM Plex Sans Thai',
  fontWeight: 'bold',
  fontSize: '0.75rem',
  color: '#FFF',
  padding: '0px 12px',
  background: `${props.status ? v.tagColors[props.status] : v.tagDraft}`,
  width: 'fit-content',
  borderRadius: `${props.allRadius ? '10px' : '10px 0px'}`,
  lineHeight:'1.5em',
  height:'1.5em',
  marginLeft:`${props.marginLeft||0}`
}))

export const ActionButtonContainer = styled.div({
  display: 'flex', 
  button: { 
    span: { 
      'svg.MuiSvgIcon-root': { 
        fontSize: '1.1rem',
      } 
    }
  }
})